import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { toast } from "react-toastify";
import CheckboxField from "../reuse/CheckboxField";
import { useDataContext } from "../../context/DataContext";
import useAxiosPrivate from "../hooks/useAxiosPrivate";
import { genericErrorMessage } from "../../constants";

const DetailsWrapper = styled.div`
  padding: 20px;
  border: 1px solid ${({ theme }) => theme.branding.borderColor};
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  gap: 15px;
  background-color: ${({ theme }) => theme.branding.color};
  margin: 20px;
  /* margin-top: 20px;
  margin-bottom: 20px; */

  @media (max-width: 768px) {
    margin: 20px 0px;
  }
`;

const Content = styled.div`
  padding: 10px;
  border: 1px solid ${({ theme }) => theme.branding.borderColor};
  border-radius: 4px;
`;

const MessageContent = styled(Content)`
  background: ${({ theme }) => theme.branding.lightBlue};
`;

const ContentText = styled.div`
  font-weight: 600;
  font-size: 14px;
  display: flex;
  align-items: center;
  text-align: center;
`;

function MessageToRequestor({
  requestorId,
  messageInformation,
  messageToRequestor,
}) {
  const { data, setData } = useDataContext();

  const axiosPrivate = useAxiosPrivate();

  // Find the item in data corresponding to the current id
  const currentItem = data.find((item) => item.id_F === requestorId);

  // Initialize isChecked state, load with inital value from data
  const [isChecked, setIsChecked] = useState(
    currentItem ? currentItem.reviewByRequestor_F : false,
  );

  // Update isChecked state when data changes (in case data is dynamic)
  useEffect(() => {
    if (currentItem) {
      setIsChecked(currentItem.reviewByRequestor_F);
    }
  }, [currentItem]);

  // eslint-disable-next-line consistent-return
  const handleConfirmCheckbox = async (e) => {
    e.preventDefault();

    try {
      if (currentItem?.currentStatus_F !== "Open") {
        return false;
      }

      setIsChecked(!isChecked);

      /*
      // Update data context based on id and isChecked
      const updatedData = data.map((item) => {
        if (item.id_F === parseInt(requestorId, 10)) {
          return {
            ...item,
            reviewByRequestor_F: !isChecked,
          };
        }
        return item;
      });

      // save to backend and then setData
      setData(updatedData);
*/

      const payload = {
        fields: {
          reviewByRequestor_F: { value: !isChecked },
        },
      };

      const response = await axiosPrivate.post(
        `request/v2/upload/${requestorId}`,
        payload,
      );

      if (response.data.length > 0) {
        setData((prevItems) =>
          prevItems.map((item) =>
            item.id_F === requestorId ? { ...item, ...response.data[0] } : item,
          ),
        );
      }
    } catch (err) {
      toast.error(genericErrorMessage);
    }
  };

  return (
    <DetailsWrapper>
      <MessageContent>
        <ContentText>
          <div
            dangerouslySetInnerHTML={{
              __html: messageInformation,
            }}
          />
        </ContentText>
      </MessageContent>
      <Content>
        <div
          dangerouslySetInnerHTML={{
            __html: messageToRequestor,
          }}
        />
      </Content>
      <CheckboxField
        label="I have reviewed the information below and confirmed that it is accurate."
        helpText="He revisado la información a continuación y he confirmado que es preciso."
        checked={isChecked}
        onChange={handleConfirmCheckbox}
      />
    </DetailsWrapper>
  );
}

export default React.memo(MessageToRequestor);
